var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "edit_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M39.171 5 59 24.829l-7.07 7.07-19.83-19.83zM28.768 15.403 5 39.17V59h19.829l23.768-23.768z",
    clipRule: "evenodd"
  })));
};
export { SvgEdit as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTM5LjE3MTEgNUw1OSAyNC44Mjg5TDUxLjkyOTcgMzEuODk4OUwzMi4xMDA5IDEyLjA2OTlMMzkuMTcxMSA1Wk0yOC43Njc5IDE1LjQwMjZMNSAzOS4xNzA3VjU4Ljk5OTVIMjQuODI4OUw0OC41OTcgMzUuMjMxNkwyOC43Njc5IDE1LjQwMjZaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";